import useRxStore from './use-rx-store';
import SessionStore from '../rx-stores/session';
import { SessionStatus } from '../types/session';

export function getSessionToken<T>(defaultValue: T = null): string | T {
  const session = SessionStore.imperativelyGetValue();
  if (session.status !== SessionStatus.LOGGED_IN) {
    return defaultValue;
  } else {
    return session.token;
  }
}

export function getRequiredSessionToken(): string {
  const token = getSessionToken(null);
  if (token === null) {
    throw new Error('Session token is required, but does not exist');
  }
  return token;
}

export function useRequiredSessionToken(): string {
  const session = useRxStore(SessionStore);

  if (session.status !== SessionStatus.LOGGED_IN) {
    throw new Error('Session token is required to render this component');
  }
  return session.token;
}
